import { BaseService, Service } from "/@/cool";

@Service("cartoon")
class Cartoon extends BaseService {
	constructor() {
		super();

		let prefix = "";
		if (this.namespace) {
			prefix = this.namespace.replace(/\//g, ":") + ":";
		}

		this.permission["list"] = prefix + "list";
		this.permission["page"] = prefix + "page";
		this.permission["info"] = prefix + "info";
		this.permission["style"] = prefix + "style";
		this.permission["uploadUrl"] = prefix + "uploadUrl";
		this.permission["putModeling"] = prefix + "putModeling";
		this.permission["cartoonList"] = prefix + "cartoonList";
		this.permission["cartoonInfo"] = prefix + "cartoonInfo";
		this.permission["check"] = prefix + "check";
		this.permission["shapeList"] = prefix + "shapeList";
		this.permission["fontList"] = prefix + "fontList";
		this.permission["compositeImage"] = prefix + "compositeImage";
		this.permission["eceChannelPage"] = prefix + "eceChannelPage";
		this.permission["eceChannelList"] = prefix + "eceChannelList";
		this.permission["eceChannelInfo"] = prefix + "eceChannelInfo";
		this.permission["addEceChannel"] = prefix + "addEceChannel";
		this.permission["updateEceChannel"] = prefix + "updateEceChannel";
		this.permission["deleteEceChannel"] = prefix + "deleteEceChannel";
		this.permission["eceLinkPage"] = prefix + "eceLinkPage";
		this.permission["addEceLink"] = prefix + "addEceLink";
		this.permission["addExchangeCount"] = prefix + "addExchangeCount";
		this.permission["addImageCount"] = prefix + "addImageCount";
		this.permission["delayExpiredTime"] = prefix + "delayExpiredTime";
		this.permission["createImages"] = prefix + "createImages";
		this.permission["importCartoonImages"] = prefix + "importCartoonImages";
		this.permission["uploadImageToOss"] = prefix + "uploadImageToOss";
		this.permission["uploadImageToOssV2"] = prefix + "uploadImageToOssV2";
		this.permission["secret"] = prefix + "secret";
		this.permission["materialPage"] = prefix + "materialPage";
		this.permission["cateList"] = prefix + "cateList";
		this.permission["uploadImage"] = prefix + "uploadImage";
		this.permission["importMaterial"] = prefix + "importMaterial";
		this.permission["materialInfo"] = prefix + "materialInfo";
		this.permission["searchCustomer"] = prefix + "searchCustomer";
		this.permission["cateAndSubject"] = prefix + "cateAndSubject";
		this.permission["generateViews"] = prefix + "generateViews";
		this.permission["listViews"] = prefix + "listViews";
		this.permission["flipViews"] = prefix + "flipViews";
		this.permission["confirmViews"] = prefix + "confirmViews";
		this.permission["eceOrderPage"] = prefix + "eceOrderPage";
		this.permission["addEceOrder"] = prefix + "addEceOrder";
		this.permission["addExchangeCountV2"] = prefix + "addExchangeCountV2";
		this.permission["addImageCountV2"] = prefix + "addImageCountV2";
		this.permission["delayExpiredTimeV2"] = prefix + "delayExpiredTimeV2";
		this.permission["mountsList"] = prefix + "mountsList";
		this.permission["getSizes"] = prefix + "getSizes";
	}

	style(params: any) {
		return this.request({
			url: "/style",
			method: "POST",
			data: {
				...params
			}
		});
	}

	uploadUrl(params: any) {
		return this.request({
			url: "/uploadUrl",
			method: "POST",
			data: {
				...params
			}
		});
	}

	putModeling(params: any) {
		return this.request({
			url: "/putModeling",
			method: "POST",
			data: {
				...params
			}
		});
	}

	cartoonList(params: any) {
		return this.request({
			url: "/cartoonList",
			method: "POST",
			data: {
				...params
			}
		});
	}

	cartoonInfo(params: any) {
		return this.request({
			url: "/cartoonInfo",
			method: "POST",
			data: {
				...params
			}
		});
	}

	cartoonCheck(params: any) {
		return this.request({
			url: "/check",
			method: "POST",
			data: {
				...params
			}
		});
	}

	shapeList(params: any) {
		return this.request({
			url: "/shapeList",
			method: "POST",
			data: {
				...params
			}
		});
	}

	fontList(params: any) {
		return this.request({
			url: "/fontList",
			method: "POST",
			data: {
				...params
			}
		});
	}

	compositeImage(params: any) {
		return this.request({
			url: "/compositeImage",
			method: "POST",
			data: {
				...params
			}
		});
	}

	materialPage(params: any) {
		return this.request({
			url: "/materialPage",
			method: "POST",
			data: {
				...params
			}
		});
	}

	cateList(params: any) {
		return this.request({
			url: "/cateList",
			method: "POST",
			data: {
				...params
			}
		});
	}

	uploadImage(url: string, file: File) {
		return this.request({
			url,
			method: "PUT",
			data: file,
			timeout: 180000, // 180 秒
			headers: {
				"Content-Type": "image/jpeg"
			}
		});
	}

	importMaterial(params: any) {
		return this.request({
			url: "/importMaterial",
			method: "POST",
			data: {
				...params
			}
		});
	}

	eceChannelPage(params: any) {
		return this.request({
			url: "/eceChannelPage",
			method: "POST",
			data: {
				...params
			}
		});
	}
	eceChannelList(params: any) {
		return this.request({
			url: "/eceChannelList",
			method: "POST",
			data: {
				...params
			}
		});
	}
	eceChannelInfo(params: any) {
		return this.request({
			url: "/eceChannelInfo",
			method: "POST",
			data: {
				...params
			}
		});
	}
	addEceChannel(params: any) {
		return this.request({
			url: "/addEceChannel",
			method: "POST",
			data: {
				...params
			}
		});
	}
	updateEceChannel(params: any) {
		return this.request({
			url: "/updateEceChannel",
			method: "POST",
			data: {
				...params
			}
		});
	}
	eceLinkPage(params: any) {
		return this.request({
			url: "/eceLinkPage",
			method: "POST",
			data: {
				...params
			}
		});
	}
	addEceLink(params: any) {
		return this.request({
			url: "/addEceLink",
			method: "POST",
			data: {
				...params
			}
		});
	}
	addExchangeCount(params: any) {
		return this.request({
			url: "/addExchangeCount",
			method: "POST",
			data: {
				...params
			}
		});
	}
	addImageCount(params: any) {
		return this.request({
			url: "/addImageCount",
			method: "POST",
			data: {
				...params
			}
		});
	}
	delayExpiredTime(params: any) {
		return this.request({
			url: "/delayExpiredTime",
			method: "POST",
			data: {
				...params
			}
		});
	}
	createImages(params: any) {
		return this.request({
			url: "/createImages",
			method: "POST",
			data: {
				...params
			}
		});
	}
	importCartoonImages(params: any) {
		return this.request({
			url: "/importCartoonImages",
			method: "POST",
			data: {
				...params
			}
		});
	}
	uploadImageToOss(params: any) {
		return this.request({
			url: "/uploadImageToOss",
			method: "POST",
			data: {
				...params
			}
		});
	}
	uploadImageToOssV2(params: any) {
		return this.request({
			url: "/uploadImageToOssV2",
			method: "POST",
			data: {
				...params
			}
		});
	}
	secret(params: any) {
		return this.request({
			url: "/secret",
			method: "POST",
			data: {
				...params
			}
		});
	}
	materialInfo(params: any) {
		return this.request({
			url: "/materialInfo",
			method: "POST",
			data: {
				...params
			}
		});
	}

	searchCustomer(params: any) {
		return this.request({
			url: "/searchCustomer",
			method: "POST",
			data: {
				...params
			}
		});
	}

	cateAndSubject(params: any) {
		return this.request({
			url: "/cateAndSubject",
			method: "POST",
			data: {
				...params
			}
		});
	}

	generateViews(params: any) {
		return this.request({
			url: "/generateViews",
			method: "POST",
			data: {
				...params
			}
		});
	}

	listViews(params: any) {
		return this.request({
			url: "/listViews",
			method: "POST",
			data: {
				...params
			}
		});
	}

	flipViews(params: any) {
		return this.request({
			url: "/flipViews",
			method: "POST",
			data: {
				...params
			}
		});
	}

	confirmViews(params: any) {
		return this.request({
			url: "/confirmViews",
			method: "POST",
			data: {
				...params
			}
		});
	}
	eceOrderPage(params: any) {
		return this.request({
			url: "/eceOrderPage",

			method: "POST",
			data: {
				...params
			}
		});
	}
	addEceOrder(params: any) {
		return this.request({
			url: "/addEceOrder",

			method: "POST",
			data: {
				...params
			}
		});
	}
	addExchangeCountV2(params: any) {
		return this.request({
			url: "/addExchangeCountV2",

			method: "POST",
			data: {
				...params
			}
		});
	}
	addImageCountV2(params: any) {
		return this.request({
			url: "/addImageCountV2",
			method: "POST",
			data: {
				...params
			}
		});
	}
	delayExpiredTimeV2(params: any) {
		return this.request({
			url: "/delayExpiredTimeV2",
			method: "POST",
			data: {
				...params
			}
		});
	}
	mountsList(params: any) {
		return this.request({
			url: "/mountsList",
			method: "POST",
			data: {
				...params
			}
		});
	}
	getSizes(params: any) {
		return this.request({
			url: "/getSizes",
			method: "POST",
			data: {
				...params
			}
		});
	}
}

export default Cartoon;
